import { CSSResult, CSSResultArray, unsafeCSS } from 'lit'
import { css } from 'lit'
import { csColorText } from '@cloudsuite/mosaic-shared/styles/colors.style.js'


export const csFontFamilyBody = css`var(--cs-font-family-body, Roboto, Arial, sans-serif)`
export const csFontFamilyHeadings = css`var(--cs-font-family-headings, Poppins, Arial, sans-serif)`

interface Font {
  color: CSSResult,
  fontFamily: CSSResult,
  fontSize: CSSResult,
  fontSizeMobile: CSSResult,
  fontWeight: CSSResult,
  lineHeight: CSSResult,
  letterSpacing: CSSResult,
  textTransform: CSSResult,
  textDecoration: CSSResult,
  fontStyle: CSSResult,
  textShadow: CSSResult
}

export const csFontLargerTitle: Font = {
  color: css`var(--cs-font-larger-title-color, ${csColorText.headings})`,
  fontFamily: css`var(--cs-font-larger-title-font-family, ${csFontFamilyHeadings})`,
  fontSize: css`var(--cs-font-larger-title-font-size, 52px)`,
  fontSizeMobile: css`var(--cs-font-larger-title-font-size-mobile, 44px)`,
  fontWeight: css`var(--cs-font-larger-title-font-weight, 500)`,
  lineHeight: css`var(--cs-font-larger-title-line-height, 1.2)`,
  letterSpacing: css`var(--cs-font-larger-title-letter-spacing, normal)`,
  textTransform: css`var(--cs-font-larger-title-text-transform, none)`,
  fontStyle: css`var(--cs-font-larger-title-font-style, normal)`,
  textDecoration: css`var(--cs-font-larger-title-text-decoration, none)`,
  textShadow: css`var(--cs-font-larger-title-text-shadow, none)`,
}

export const csFontLargeTitle: Font = {
  color: css`var(--cs-font-large-title-color, ${csColorText.headings})`,
  fontFamily: css`var(--cs-font-large-title-font-family, ${csFontFamilyHeadings})`,
  fontSize: css`var(--cs-font-large-title-font-size, 44px)`,
  fontSizeMobile: css`var(--cs-font-large-title-font-size-mobile, 38px)`,
  fontWeight: css`var(--cs-font-large-title-font-weight, 500)`,
  lineHeight: css`var(--cs-font-large-title-line-height, 1.2)`,
  letterSpacing: css`var(--cs-font-large-title-letter-spacing, normal)`,
  textTransform: css`var(--cs-font-large-title-text-transform, none)`,
  fontStyle: css`var(--cs-font-large-title-font-style, normal)`,
  textDecoration: css`var(--cs-font-large-title-text-decoration, none)`,
  textShadow: css`var(--cs-font-large-title-text-shadow, none)`,
}

export const csFontHeading1: Font = {
  color: css`var(--cs-font-heading-1-color, ${csColorText.headings})`,
  fontFamily: css`var(--cs-font-heading-1-font-family, ${csFontFamilyHeadings})`,
  fontSize: css`var(--cs-font-heading-1-font-size, 36px)`,
  fontSizeMobile: css`var(--cs-font-heading-1-font-size-mobile, 32px)`,
  fontWeight: css`var(--cs-font-heading-1-font-weight, 500)`,
  lineHeight: css`var(--cs-font-heading-1-line-height, 1.2)`,
  letterSpacing: css`var(--cs-font-heading-1-letter-spacing, normal)`,
  textTransform: css`var(--cs-font-heading-1-text-transform, none)`,
  fontStyle: css`var(--cs-font-heading-1-font-style, normal)`,
  textDecoration: css`var(--cs-font-heading-1-text-decoration, none)`,
  textShadow: css`var(--cs-font-heading-1-text-shadow, none)`,
}

export const csFontHeading2: Font = {
  color: css`var(--cs-font-heading-2-color, ${csColorText.headings})`,
  fontFamily: css`var(--cs-font-heading-2-font-family, ${csFontFamilyHeadings})`,
  fontSize: css`var(--cs-font-heading-2-font-size, 30px)`,
  fontSizeMobile: css`var(--cs-font-heading-2-font-size-mobile, 26px)`,
  fontWeight: css`var(--cs-font-heading-2-font-weight, 500)`,
  lineHeight: css`var(--cs-font-heading-2-line-height, 1.2)`,
  letterSpacing: css`var(--cs-font-heading-2-letter-spacing, normal)`,
  textTransform: css`var(--cs-font-heading-2-text-transform, none)`,
  fontStyle: css`var(--cs-font-heading-2-font-style, normal)`,
  textDecoration: css`var(--cs-font-heading-2-text-decoration, none)`,
  textShadow: css`var(--cs-font-heading-2-text-shadow, none)`,
}

export const csFontHeading3: Font = {
  color: css`var(--cs-font-heading-3-color, ${csColorText.headings})`,
  fontFamily: css`var(--cs-font-heading-3-font-family, ${csFontFamilyHeadings})`,
  fontSize: css`var(--cs-font-heading-3-font-size, 24px)`,
  fontSizeMobile: css`var(--cs-font-heading-3-font-size-mobile, 22px)`,
  fontWeight: css`var(--cs-font-heading-3-font-weight, 500)`,
  lineHeight: css`var(--cs-font-heading-3-line-height, 1.2)`,
  letterSpacing: css`var(--cs-font-heading-3-letter-spacing, normal)`,
  textTransform: css`var(--cs-font-heading-3-text-transform, none)`,
  fontStyle: css`var(--cs-font-heading-3-font-style, normal)`,
  textDecoration: css`var(--cs-font-heading-3-text-decoration, none)`,
  textShadow: css`var(--cs-font-heading-3-text-shadow, none)`,
}

export const csFontHeading4: Font = {
  color: css`var(--cs-font-heading-4-color, ${csColorText.headings})`,
  fontFamily: css`var(--cs-font-heading-4-font-family, ${csFontFamilyHeadings})`,
  fontSize: css`var(--cs-font-heading-4-font-size, 20px)`,
  fontSizeMobile: css`var(--cs-font-heading-4-font-size-mobile, 18px)`,
  fontWeight: css`var(--cs-font-heading-4-font-weight, 500)`,
  lineHeight: css`var(--cs-font-heading-4-line-height, 1.2)`,
  letterSpacing: css`var(--cs-font-heading-4-letter-spacing, normal)`,
  textTransform: css`var(--cs-font-heading-4-text-transform, none)`,
  fontStyle: css`var(--cs-font-heading-4-font-style, normal)`,
  textDecoration: css`var(--cs-font-heading-4-text-decoration, none)`,
  textShadow: css`var(--cs-font-heading-4-text-shadow, none)`,
}

export const csFontHeading5: Font = {
  color: css`var(--cs-font-heading-5-color, ${csColorText.headings})`,
  fontFamily: css`var(--cs-font-heading-5-font-family, ${csFontFamilyBody})`,
  fontSize: css`var(--cs-font-heading-5-font-size, 18px)`,
  fontSizeMobile: css`var(--cs-font-heading-5-font-size-mobile, 16px)`,
  fontWeight: css`var(--cs-font-heading-5-font-weight, 700)`,
  lineHeight: css`var(--cs-font-heading-5-line-height, 1.2)`,
  letterSpacing: css`var(--cs-font-heading-5-letter-spacing, normal)`,
  textTransform: css`var(--cs-font-heading-5-text-transform, none)`,
  fontStyle: css`var(--cs-font-heading-5-font-style, normal)`,
  textDecoration: css`var(--cs-font-heading-5-text-decoration, none)`,
  textShadow: css`var(--cs-font-heading-5-text-shadow, none)`,
}

export const csFontHeading6: Font = {
  color: css`var(--cs-font-heading-6-color, ${csColorText.headings})`,
  fontFamily: css`var(--cs-font-heading-6-font-family, ${csFontFamilyBody})`,
  fontSize: css`var(--cs-font-heading-6-font-size, 16px)`,
  fontSizeMobile: css`var(--cs-font-heading-6-font-size-mobile, 14px)`,
  fontWeight: css`var(--cs-font-heading-6-font-weight, 700)`,
  lineHeight: css`var(--cs-font-heading-6-line-height, 1.2)`,
  letterSpacing: css`var(--cs-font-heading-6-letter-spacing, normal)`,
  textTransform: css`var(--cs-font-heading-6-text-transform, none)`,
  fontStyle: css`var(--cs-font-heading-6-font-style, normal)`,
  textDecoration: css`var(--cs-font-heading-6-text-decoration, none)`,
  textShadow: css`var(--cs-font-heading-6-text-shadow, none)`,
}

export const csFontProductTitleL: Font = {
  color: css`var(--cs-font-product-title-l-color, ${csColorText.headings})`,
  fontFamily: css`var(--cs-font-product-title-l-font-family, ${csFontFamilyBody})`,
  fontSize: css`var(--cs-font-product-title-l-font-size, 18px)`,
  fontSizeMobile: css`var(--cs-font-product-title-l-font-size-mobile, 18px)`,
  fontWeight: css`var(--cs-font-product-title-l-font-weight, 700)`,
  lineHeight: css`var(--cs-font-product-title-l-line-height, 1.2)`,
  letterSpacing: css`var(--cs-font-product-title-l-letter-spacing, normal)`,
  textTransform: css`var(--cs-font-product-title-l-text-transform, none)`,
  fontStyle: css`var(--cs-font-product-title-l-font-style, normal)`,
  textDecoration: css`var(--cs-font-product-title-l-text-decoration, none)`,
  textShadow: css`var(--cs-font-product-title-l-text-shadow, none)`,
}

export const csFontProductTitleM: Font = {
  color: css`var(--cs-font-product-title-m-color, ${csColorText.headings})`,
  fontFamily: css`var(--cs-font-product-title-m-font-family, ${csFontFamilyBody})`,
  fontSize: css`var(--cs-font-product-title-m-font-size, 16px)`,
  fontSizeMobile: css`var(--cs-font-product-title-m-font-size-mobile, 16px)`,
  fontWeight: css`var(--cs-font-product-title-m-font-weight, 700)`,
  lineHeight: css`var(--cs-font-product-title-m-line-height, 1.2)`,
  letterSpacing: css`var(--cs-font-product-title-m-letter-spacing, normal)`,
  textTransform: css`var(--cs-font-product-title-m-text-transform, none)`,
  fontStyle: css`var(--cs-font-product-title-m-font-style, normal)`,
  textDecoration: css`var(--cs-font-product-title-m-text-decoration, none)`,
  textShadow: css`var(--cs-font-product-title-m-text-shadow, none)`,
}

export const csFontProductTitleS: Font = {
  color: css`var(--cs-font-product-title-s-color, ${csColorText.headings})`,
  fontFamily: css`var(--cs-font-product-title-s-font-family, ${csFontFamilyBody})`,
  fontSize: css`var(--cs-font-product-title-s-font-size, 14px)`,
  fontSizeMobile: css`var(--cs-font-product-title-s-font-size-mobile, 14px)`,
  fontWeight: css`var(--cs-font-product-title-s-font-weight, 700)`,
  lineHeight: css`var(--cs-font-product-title-s-line-height, 1.2)`,
  letterSpacing: css`var(--cs-font-product-title-s-letter-spacing, normal)`,
  textTransform: css`var(--cs-font-product-title-s-text-transform, none)`,
  fontStyle: css`var(--cs-font-product-title-s-font-style, normal)`,
  textDecoration: css`var(--cs-font-product-title-s-text-decoration, none)`,
  textShadow: css`var(--cs-font-product-title-s-text-shadow, none)`,
}

export const csFontIntro: Font = {
  color: css`var(--cs-font-intro-color, ${csColorText.body})`,
  fontFamily: css`var(--cs-font-intro-font-family, ${csFontFamilyHeadings})`,
  fontSize: css`var(--cs-font-intro-font-size, 20px)`,
  fontSizeMobile: css`var(--cs-font-intro-font-size-mobile, 18px)`,
  fontWeight: css`var(--cs-font-intro-font-weight, 300)`,
  lineHeight: css`var(--cs-font-intro-line-height, 1.2)`,
  letterSpacing: css`var(--cs-font-intro-letter-spacing, normal)`,
  textTransform: css`var(--cs-font-intro-text-transform, none)`,
  fontStyle: css`var(--cs-font-intro-font-style, normal)`,
  textDecoration: css`var(--cs-font-intro-text-decoration, none)`,
  textShadow: css`var(--cs-font-intro-text-shadow, none)`,
}

export const csFontQuote: Font = {
  color: css`var(--cs-font-quote-color, ${csColorText.body})`,
  fontFamily: css`var(--cs-font-quote-font-family, ${csFontFamilyHeadings})`,
  fontSize: css`var(--cs-font-quote-font-size, 30px)`,
  fontSizeMobile: css`var(--cs-font-quote-font-size-mobile, 26px)`,
  fontWeight: css`var(--cs-font-quote-font-weight, 500)`,
  lineHeight: css`var(--cs-font-quote-line-height, 1.2)`,
  letterSpacing: css`var(--cs-font-quote-letter-spacing, normal)`,
  textTransform: css`var(--cs-font-quote-text-transform, none)`,
  fontStyle: css`var(--cs-font-quote-font-style, normal)`,
  textDecoration: css`var(--cs-font-quote-text-decoration, none)`,
  textShadow: css`var(--cs-font-quote-text-shadow, none)`,
}

export const csFontBody: Font = {
  color: css`var(--cs-font-body-color, ${csColorText.body})`,
  fontFamily: css`var(--cs-font-body-font-family, ${csFontFamilyBody})`,
  fontSize: css`var(--cs-font-body-font-size, 16px)`,
  fontSizeMobile: css`var(--cs-font-body-font-size-mobile, 16px)`,
  fontWeight: css`var(--cs-font-body-font-weight, 400)`,
  lineHeight: css`var(--cs-font-body-line-height, 1.5)`,
  letterSpacing: css`var(--cs-font-body-letter-spacing, normal)`,
  textTransform: css`var(--cs-font-body-text-transform, none)`,
  fontStyle: css`var(--cs-font-body-font-style, normal)`,
  textDecoration: css`var(--cs-font-body-text-decoration, none)`,
  textShadow: css`var(--cs-font-body-text-shadow, none)`,
}

export const csFontBodyS: Font = {
  color: css`var(--cs-font-body-s-color, ${csColorText.body})`,
  fontFamily: css`var(--cs-font-body-s-font-family, ${csFontFamilyBody})`,
  fontSize: css`var(--cs-font-body-s-font-size, 14px)`,
  fontSizeMobile: css`var(--cs-font-body-s-font-size-mobile, 14px)`,
  fontWeight: css`var(--cs-font-body-s-font-weight, 400)`,
  lineHeight: css`var(--cs-font-body-s-line-height, 1.5)`,
  letterSpacing: css`var(--cs-font-body-s-letter-spacing, normal)`,
  textTransform: css`var(--cs-font-body-s-text-transform, none)`,
  fontStyle: css`var(--cs-font-body-s-font-style, normal)`,
  textDecoration: css`var(--cs-font-body-s-text-decoration, none)`,
  textShadow: css`var(--cs-font-body-s-text-shadow, none)`,
}

export const csFontCaptionL: Font = {
  color: css`var(--cs-font-caption-l-color, ${csColorText.muted})`,
  fontFamily: css`var(--cs-font-caption-l-font-family, ${csFontFamilyBody})`,
  fontSize: css`var(--cs-font-caption-l-font-size, 16px)`,
  fontSizeMobile: css`var(--cs-font-caption-l-font-size-mobile, 16px)`,
  fontWeight: css`var(--cs-font-caption-l-font-weight, 400)`,
  lineHeight: css`var(--cs-font-caption-l-line-height, 1.5)`,
  letterSpacing: css`var(--cs-font-caption-l-letter-spacing, normal)`,
  textTransform: css`var(--cs-font-caption-l-text-transform, none)`,
  fontStyle: css`var(--cs-font-caption-l-font-style, normal)`,
  textDecoration: css`var(--cs-font-caption-l-text-decoration, none)`,
  textShadow: css`var(--cs-font-caption-l-text-shadow, none)`,
}

export const csFontCaptionM: Font = {
  color: css`var(--cs-font-caption-m-color, ${csColorText.muted})`,
  fontFamily: css`var(--cs-font-caption-m-font-family, ${csFontFamilyBody})`,
  fontSize: css`var(--cs-font-caption-m-font-size, 14px)`,
  fontSizeMobile: css`var(--cs-font-caption-m-font-size-mobile, 14px)`,
  fontWeight: css`var(--cs-font-caption-m-font-weight, 400)`,
  lineHeight: css`var(--cs-font-caption-m-line-height, 1.2)`,
  letterSpacing: css`var(--cs-font-caption-m-letter-spacing, normal)`,
  textTransform: css`var(--cs-font-caption-m-text-transform, none)`,
  fontStyle: css`var(--cs-font-caption-m-font-style, normal)`,
  textDecoration: css`var(--cs-font-caption-m-text-decoration, none)`,
  textShadow: css`var(--cs-font-caption-m-text-shadow, none)`,
}

export const csFontCaptionS: Font = {
  color: css`var(--cs-font-caption-s-color, ${csColorText.muted})`,
  fontFamily: css`var(--cs-font-caption-s-font-family, ${csFontFamilyBody})`,
  fontSize: css`var(--cs-font-caption-s-font-size, 12px)`,
  fontSizeMobile: css`var(--cs-font-caption-s-font-size-mobile, 12px)`,
  fontWeight: css`var(--cs-font-caption-s-font-weight, 500)`,
  lineHeight: css`var(--cs-font-caption-s-line-height, 1.2)`,
  letterSpacing: css`var(--cs-font-caption-s-letter-spacing, 0.3px)`,
  textTransform: css`var(--cs-font-caption-s-text-transform, uppercase)`,
  fontStyle: css`var(--cs-font-caption-s-font-style, normal)`,
  textDecoration: css`var(--cs-font-caption-s-text-decoration, none)`,
  textShadow: css`var(--cs-font-caption-s-text-shadow, none)`,
}

export const csFontPriceL: Font = {
  color: css`var(--cs-font-price-l-color, ${csColorText.body})`,
  fontFamily: css`var(--cs-font-price-l-font-family, ${csFontFamilyBody})`,
  fontSize: css`var(--cs-font-price-l-font-size, 28px)`,
  fontSizeMobile: css`var(--cs-font-price-l-font-size-mobile, 22px)`,
  fontWeight: css`var(--cs-font-price-l-font-weight, 700)`,
  lineHeight: css`var(--cs-font-price-l-line-height, 1.2)`,
  letterSpacing: css`var(--cs-font-price-l-letter-spacing, normal)`,
  textTransform: css`var(--cs-font-price-l-text-transform, none)`,
  fontStyle: css`var(--cs-font-price-l-font-style, normal)`,
  textDecoration: css`var(--cs-font-price-l-text-decoration, none)`,
  textShadow: css`var(--cs-font-price-l-text-shadow, none)`,
}

export const csFontPriceM: Font = {
  color: css`var(--cs-font-price-m-color, ${csColorText.body})`,
  fontFamily: css`var(--cs-font-price-m-font-family, ${csFontFamilyBody})`,
  fontSize: css`var(--cs-font-price-m-font-size, 20px)`,
  fontSizeMobile: css`var(--cs-font-price-m-font-size-mobile, 18px)`,
  fontWeight: css`var(--cs-font-price-m-font-weight, 700)`,
  lineHeight: css`var(--cs-font-price-m-line-height, 1.2)`,
  letterSpacing: css`var(--cs-font-price-m-letter-spacing, normal)`,
  textTransform: css`var(--cs-font-price-m-text-transform, none)`,
  fontStyle: css`var(--cs-font-price-m-font-style, normal)`,
  textDecoration: css`var(--cs-font-price-m-text-decoration, none)`,
  textShadow: css`var(--cs-font-price-m-text-shadow, none)`,
}

export const csFontPriceS: Font = {
  color: css`var(--cs-font-price-s-color, ${csColorText.body})`,
  fontFamily: css`var(--cs-font-price-s-font-family, ${csFontFamilyBody})`,
  fontSize: css`var(--cs-font-price-s-font-size, 16px)`,
  fontSizeMobile: css`var(--cs-font-price-s-font-size-mobile, 14px)`,
  fontWeight: css`var(--cs-font-price-s-font-weight, 700)`,
  lineHeight: css`var(--cs-font-price-s-line-height, 1.2)`,
  letterSpacing: css`var(--cs-font-price-s-letter-spacing, normal)`,
  textTransform: css`var(--cs-font-price-s-text-transform, none)`,
  fontStyle: css`var(--cs-font-price-s-font-style, normal)`,
  textDecoration: css`var(--cs-font-price-s-text-decoration, none)`,
  textShadow: css`var(--cs-font-price-s-text-shadow, none)`,
}

export const csFontPriceDiscount: Font = {
  color: css`var(--cs-font-price-discount-color, ${csColorText.body})`,
  fontFamily: css`var(--cs-font-price-discount-font-family, ${csFontFamilyBody})`,
  fontSize: css`var(--cs-font-price-discount-font-size, 12px)`,
  fontSizeMobile: css`var(--cs-font-price-discount-font-size-mobile, 12px)`,
  fontWeight: css`var(--cs-font-price-discount-font-weight, 400)`,
  lineHeight: css`var(--cs-font-price-discount-line-height, 1.2)`,
  letterSpacing: css`var(--cs-font-price-discount-letter-spacing, normal)`,
  textTransform: css`var(--cs-font-price-discount-text-transform, none)`,
  fontStyle: css`var(--cs-font-price-discount-font-style, normal)`,
  textDecoration: css`var(--cs-font-price-discount-text-decoration, line-through)`,
  textShadow: css`var(--cs-font-price-discount-text-shadow, none)`,
}

const csFontVariants: Record<string, Font> = {
  'larger-title': csFontLargerTitle,
  'large-title': csFontLargeTitle,
  'heading-1': csFontHeading1,
  'heading-2': csFontHeading2,
  'heading-3': csFontHeading3,
  'heading-4': csFontHeading4,
  'heading-5': csFontHeading5,
  'heading-6': csFontHeading6,
  'product-title-l': csFontProductTitleL,
  'product-title-m': csFontProductTitleM,
  'product-title-s': csFontProductTitleS,
  'intro': csFontIntro,
  'quote': csFontQuote,
  'body': csFontBody,
  'body-s': csFontBodyS,
  'caption-l': csFontCaptionL,
  'caption-m': csFontCaptionM,
  'caption-s': csFontCaptionS,
  'price-l': csFontPriceL,
  'price-m': csFontPriceM,
  'price-s': csFontPriceS,
  'price-discount': csFontPriceDiscount,
}

const fontStyles: CSSResultArray = []

for (const [name, fontStyle] of Object.entries(csFontVariants)) {
  fontStyles.push(css`.font-${unsafeCSS(name)} {
    color: var(--cse-text-color, ${fontStyle['color']});
    font-family: ${fontStyle['fontFamily']};
    font-size: ${fontStyle['fontSizeMobile']};
    font-weight: ${fontStyle['fontWeight']};
    line-height: ${fontStyle['lineHeight']};
    letter-spacing: ${fontStyle['letterSpacing']};
    text-transform: ${fontStyle['textTransform']};
    text-decoration: ${fontStyle['textDecoration']};
    text-shadow: ${fontStyle['textShadow']};
    font-style: ${fontStyle['fontStyle']};

    @media (min-width: 768px) {
      font-size: ${fontStyle['fontSize']};
    }
  }`)
}

export const fontVariants = Object.keys(csFontVariants)
export type fontVariantsType = typeof fontVariants

export { fontStyles }
